import React from 'react';

import { FieldValidationIcon } from 'cstar-react-primitives';
import PropTypes from 'prop-types';

const fieldErrorProps = { id: 'foo', validationProps: { id: 'bar', isInvalid: true, type: 'error', showIcon: true, showMessage: false } };

export const FieldError = ({message}) => (
    <span
        className="field-msg field-msg--error"
        aria-live="polite"
        aria-relevant="additions text"
    >
        <FieldValidationIcon id="foobar" {...fieldErrorProps} />
        <span>{message}</span>
    </span>
);

FieldError.propTypes = {
    message: PropTypes.string.isRequired
};
